import { CHARGE_STATUS } from "./charge.type";

export enum TRAFFICFINE_STATUS {
  OVERDUE = "overdue",
  PAID = "paid",
  OPEN = "open",
}

export type RENTER = {
  id: string;
  name: string;
  cpf: string;
};

export type PARTNER = {
  managementTrafficfines: boolean;
  id: string;
  name: string;
  cnpj: string;
  managementTrafficFines: boolean;
};

export type TRAFFICFINE_DETAILS = {
  placa: string;
  datahora: string;
  situacao: string;
  descricao: string;
  valor_total: number;
  auto_infracao: string;
  chave_infracao: string;
  codigo_infracao: string;
  data_vencimento: string;
  codigo_orgao_autuador: string;
  gravity: string;
};

export type ITrafficFine = {
  statusCharge: CHARGE_STATUS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  charge: any;
  _id?: string;
  licensePlate: string;
  date: Date;
  value: number;
  trafficTicket: string;
  description: string;
  renter: RENTER;
  partner: PARTNER;
  status: string | string[];
  details: TRAFFICFINE_DETAILS;
  attached?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observations?: any[];
  createdAt: Date;
  updatedAt: Date;
};

export const emptyTrafficFine = (): ITrafficFine => ({
  _id: "",
  licensePlate: "",
  date: new Date(),
  value: 0,
  trafficTicket: "",
  description: "",
  renter: { id: "", name: "", cpf: "" },
  partner: {
    id: "",
    name: "",
    cnpj: "",
    managementTrafficFines: false,
    managementTrafficfines: false,
  },
  status: [],
  details: {
    placa: "",
    datahora: "",
    situacao: "",
    descricao: "",
    valor_total: 0,
    auto_infracao: "",
    chave_infracao: "",
    codigo_infracao: "",
    data_vencimento: "",
    codigo_orgao_autuador: "",
    gravity: "",
  },
  attached: "",
  observations: [],
  createdAt: new Date(),
  updatedAt: new Date(),
  charge: undefined,
  statusCharge: CHARGE_STATUS.RECEIVED,
});

export type StatusCounterFinesReport = {
  paidFines: number;
  openFines: number;
  expiredFines: number;
  paidCharges: number;
  openCharges: number;
  expiredCharges: number;
};
